import { render } from "./HumanInfoModal.vue?vue&type=template&id=0ad16569&ts=true"
import script from "./HumanInfoModal.vue?vue&type=script&lang=ts"
export * from "./HumanInfoModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__